import Vue from 'vue';
const diyStates = {
    toggle: false,
    toggleConfirmation: false,
    togglePreLaunch: false,
    next: false,
    pageGreeting: '',
    toggleTerms: false,
    categoryDetails: {
        name: null,
        description: null,
        images: [],
    },
    productDetails: {
        name: null,
        description: null,
        price: null,
        productSections: [],
        productDetails: [],
        images: [],
    },
    shippingDetails: {
        name: null,
        description: null,
        fee: null,
    },
    paymentGateways: [],
};
const getters = {
    toggle(state) {
        return state.toggle;
    },
    toggleConfirmation(state) {
        return state.toggleConfirmation;
    },
    next(state) {
        return state.next;
    },
    pageGreeting(state) {
        return state.pageGreeting;
    },
    categoryDetails(state) {
        return state.categoryDetails;
    },
    productDetails(state) {
        return state.productDetails;
    },
    shippingDetails(state) {
        return state.shippingDetails;
    },
    paymentGateways(state) {
        return state.paymentGateways;
    },
    toggleTerms(state) {
        return state.toggleTerms;
    },
    togglePreLaunch(state) {
        return state.togglePreLaunch;
    },
};
const mutations = {
    show(state) {
        state.toggle = true;
    },
    hide(state) {
        state.toggle = false;
    },
    showConfirmation(state) {
        state.toggleConfirmation = true;
    },
    hideConfirmation(state) {
        state.toggleConfirmation = false;
    },
    allowNavigation(state) {
        state.next = true;
    },
    restrictNavigation(state) {
        state.next = false;
    },
    updatePageGreeting(state, greeting) {
        state.pageGreeting = greeting;
    },
    updateCategoryDetails(state, payload) {
        Vue.set(state, 'categoryDetails', payload);
    },
    updateProductDetails(state, payload) {
        Vue.set(state, 'productDetails', payload);
    },
    updateShippingDetails(state, payload) {
        Vue.set(state, 'shippingDetails', payload);
    },
    updatePaymentGateways(state, payload) {
        Vue.set(state, 'paymentGateways', payload);
    },
    showTerms(state) {
        state.toggleTerms = true;
    },
    hideTerms(state) {
        state.toggleTerms = false;
    },
    showPreLaunch(state) {
        state.togglePreLaunch = true;
    },
    hidePreLaunch(state) {
        state.togglePreLaunch = false;
    },
};
export default {
    namespaced: true,
    state: diyStates,
    getters,
    mutations,
};
